import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { publicRoutes } from "./AuthGuard";
import { usePathname } from "next/navigation";
import FareAcceptancePopup from "./FareAcceptancePopup";
import { useAuth } from "@/store/auth";

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isPublic = publicRoutes.includes(pathname);

  const { user } = useAuth();

  return (
    <div className="flex h-screen">
      {!isPublic && user?.user_type_id == 3 && <FareAcceptancePopup />}

      {/* Sidebar (if not public route) */}
      {!isPublic && (
        <aside className="overflow-y-auto">
          <Sidebar />
        </aside>
      )}

      {/* Main layout */}
      <div className="flex flex-col flex-1 min-h-0">
        {/* Header (if not public route) */}
        {!isPublic && <Header />}

        {/* Main Content with padding-bottom to avoid footer overlap */}
        <main className="flex-1 overflow-auto pb-20">{children}</main>

        {/* Fixed Footer (always visible) */}
        <Footer />
      </div>
    </div>
  );
}
